document.addEventListener('DOMContentLoaded', function () {
  const addon = document.querySelector('.hk-addon-wrapper');
  const checkbox = document.getElementById('hk-serum-checkbox');
  if (!addon || !checkbox) return;

  const serumVariantId = parseInt(addon.dataset.serumVariantId, 10);
  if (!serumVariantId) return;

  // Formulario principal de añadir al carrito del tema Shrine
  const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!mainForm) return;

  const variantInput = mainForm.querySelector('input.product-variant-id');
  const quantityInput = mainForm.querySelector('input[name="quantity"]');

  // Estado del checkbox
  let serumSelected = false;

  checkbox.addEventListener('change', function () {
    serumSelected = checkbox.checked;
    addon.classList.toggle('active', serumSelected);
  });

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;

      // Interceptamos el envío antes del tema
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      if (!variantInput || !variantInput.value) {
        form.submit(); // fallback
        return;
      }

      const mainVariantId = parseInt(variantInput.value, 10);
      const qty = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) || 1 : 1;

      const items = [{ id: mainVariantId, quantity: qty }];

      if (serumSelected) {
        items.push({ id: serumVariantId, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Error al añadir al carrito');
          return res.json();
        })
        .then(function () {
          // Redirige al carrito para confirmar visualmente
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error(err);
          form.submit(); // fallback final
        });
    },
    true // Captura: intercepta antes que Shrine
  );
});
